import { UpdateExternalUserRequest } from '../../../../web-api-client';
import { ExternalUser } from '../../models';

export const mapExternalUserToUpdateRequest = (
  user: ExternalUser
): UpdateExternalUserRequest => {
  return new UpdateExternalUserRequest({
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    isActive: user.isActive,
    territory: user.territory,
    organization: user.organization,
    termsAndPrivacyAccepted: user.termsAndPrivacyAccepted ?? false,
  });
};
